/*
 * @Description: 详情弹层与审核配置
 * @Date: 2021-10-28 15:24:12
 */

import taskDetail from '../views/task-record/task-detail.vue';
import createExtend from '@C/createExtend';
import request from '@/tools/request';
import auditRow from './audit-row';
import { taskRecordListAll } from '@R/api';

const defaultDetailUrl = '/rest/cso/saas/taskRecord/info';
const auditValueKey = 'auditStatusValues';
const defaultAuditApi = '/rest/cso/saas/taskRecord/info/auditOssStatus';

/**
 * @description: 详情弹层。详情审核操作外部处理的，需要绑定this或传入getList
 * @param {object} row 当前item数据
 * @param {string | function} auditApi 审核接口
 * @param {function} auditCleanAllSelectedAjax 审核后清空列表勾选接口
 * @param {object} auditOptions 审核额外参数
 * @param {string} detailUrl 获取详情接口
 * @param {object} detailOptions 获取详情额外参数
 * @param {object} auditRecordState 详情审核按钮控制 2只展示不通过，3只展示通过，1都展示，0都不展示, -1默认（用去区分判断,使用其他字段判断操作disabled。只有在审核记录中使用了这个prop，并且审核记录中不需要通过其他字段判断disabled）
 * @param {function} getList 刷新父级列表方法
 * @param {object} tableSearchQuery 当前search query
 * @param {object} projectDetail 当前项目数据
 * @param {boolean} needNext true自动进入下一个审核，false审核后关闭u
 * @param {number} whetherThisRecordCanBeManipulated 审核记录中控制disabled，0-不可操作
 * @param {boolean} isOpenedByOther true其他页面打开，不展示操作。task-detail组件由于extends没有inject，再次以prop传入
 * @return {void}
 */
export default function({
  row,
  auditApi = defaultAuditApi,
  auditCleanAllSelectedAjax = taskRecordListAll,
  auditOptions = {},
  detailUrl = defaultDetailUrl,
  detailOptions = {},
  auditRecordState = -1,
  whetherThisRecordCanBeManipulated = 1,
  getList = this.getList,
  tableSearchQuery = {},
  projectDetail = {},
  needNext = true,
  isOpenedByOther = false
}) {
  const { projectId, type } = projectDetail;
  if (!projectId || !type) {
    throw new Error('必须传入projectDetail  {projectId,type}');
  }
  const Detil = createExtend(taskDetail, {
    row,
    detailUrl,
    auditRecordState,
    detailOptions,
    whetherThisRecordCanBeManipulated,
    isOpenedByOther
  });
  // 点击通过 获得 下一个id
  Detil.$on('pass', async function(state, emitNextTaskId) {
    const params = {
      dataState: 0, // 默认全0
      [auditValueKey]: state,
      ...tableSearchQuery,
      ...auditOptions,
      taskId: emitNextTaskId || row.taskId || row.id, // 有问题，在外部处理内容的操作，无法实时与内部同步，必须在让内容传到外部 - -
      id: emitNextTaskId || row.taskId || row.id,
      projectId,
      type
    };
    const { nextTaskId } = await auditRow({
      ajax:
        typeof auditApi === 'string'
          ? data =>
              request.post(auditApi, data, {
                serviceLoading: true
              })
          : auditApi,
      params,
      auditStatus: state,
      getList,
      cleanAllSelectedAjax: auditCleanAllSelectedAjax
    });
    if (needNext && nextTaskId) {
      await Detil.getDetail(nextTaskId);
    } else {
      Detil.remove();
    }
  });
}
